import { render, staticRenderFns } from "./DonorOrganRequestedPrint.vue?vue&type=template&id=80b2b810"
import script from "./DonorOrganRequestedPrint.vue?vue&type=script&lang=js"
export * from "./DonorOrganRequestedPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports